import {useState} from 'react';
import {Button, ButtonProps} from '@mantine/core';
import {AiOutlineImport} from 'react-icons/ai';
import {ImportAllResultDrawer} from '../drawers/ImportAllResultDrawer.tsx';

export const ImportAllRecordsButton = (props: ButtonProps) => {

    const [opened, setOpened] = useState(false);

    return (
        <>
            <Button
                variant='outline'
                leftSection={<AiOutlineImport/>}
                onClick={() => setOpened(true)}
                {...props}
            >
                Import All
            </Button>
            <ImportAllResultDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
